import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ListGroupItem, ListGroup } from 'reactstrap';
import { useSession, useFeatures, PageTitle, Button, PseudoStates, Table } from '@cordata/buffet';
import { camelCase, startCase, capitalize } from 'lodash';
import { Link, useParams, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PageLayout, Navbar } from '~/components';
import formatDate from '~/utils/format/date';
import { useTranslation } from 'react-i18next';

import {
  authorizedInstance as axios,
  authorizedPyInstance,
} from '~/utils';
import PatientSearchIdentityCard from '~/components/Patient/Identity/Search/Card';

const SideNav = ({ items }) => {
  const [t] = useTranslation();

  return (
    <ListGroup className="side-nav rounded-0" flush>
      <ListGroupItem disabled className="side-nav-item rounded-0 border-dark border-bottom-0 has-children is-open">
        Recent {capitalize(t('patients'))}
      </ListGroupItem>

      <ListGroup>
        {items?.map(i => (
          <ListGroupItem className="side-nav-item rounded-0 border-dark is-child" tag={Link} to={`/patients/${i.attributes.patientUid}`}>{i.attributes.firstName} {i.attributes.lastName}</ListGroupItem>
      ))}
      </ListGroup>
    </ListGroup>
  );
};

SideNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()),
};

SideNav.defaultProps = {
  items: undefined,
};

const LeftHand = () => {
  const [sideNavItems, setSideNavItems] = useState();
  const { current } = useSession();
  const history = useHistory();

  const handleAfterSubmit = ({ values }) =>
    history.push('/patients', { searched: true, values });

  useEffect(() => {
    if (current) {
      authorizedPyInstance
        .get('/api/data/public/list_view_cs_recent_patients', {
          params: {
            distinct: 'updated-date,patient-uid',
            user_uid: current.attributes.userUid,
            page: 1,
            'page-size': 4,
            sort: '-updated-date,patient-uid',
          },
        })
        .then(r => r.data.data)
        .then(setSideNavItems);
    }
  }, [current]);

  return (
    <>
      <PatientSearchIdentityCard afterSubmit={handleAfterSubmit} />

      {sideNavItems?.length && <SideNav items={sideNavItems} />}
    </>
  );
};

const Cell = ({ data, header }) => {
  let formattedData = data.value;

  if (header.dataType === 'date') {
    formattedData = formatDate(data.value);
  }

  return (
    <>{formattedData}</>
  );
};

Cell.propTypes = {
  data: PropTypes.shape().isRequired,
  header: PropTypes.shape().isRequired,
};

const QueuesIndex = () => {
  const history = useHistory();
  const params = useParams();
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const { hasAppIdentity } = useFeatures();

  const toggleModal = () => console.log('tiggle');

  useEffect(() => {
    if (params.queue_id) {
      axios
        .get(`queues/${params.queue_id}`)
        .then(q => q.data.data)
        .then(setData)
        .catch(setError)
        .then(() => setIsLoading(false));
    }
  }, [params.queue_id]);

  return (
    <PageLayout
      Header={Navbar}
      Left={hasAppIdentity ? <LeftHand /> : null}
    >
      {!isLoading && !error ? (
        <>
          <PageTitle
            action={data.attributes.queueName.toLowerCase() === 'new referrals' &&
              <Button
                color="secondary"
                outline
                type="button"
                onClick={toggleModal}
              >
                <FontAwesomeIcon icon="plus" />

                <span className="d-none d-md-inline ml-2">Add Referral</span>
              </Button>
            }
          >
            {startCase(data.attributes.queueName)}
          </PageTitle>

          <Link to="/home">Go back</Link>

          <Table
            filterable
            defaultFilterMethod={(filter, row) =>
              row[filter.id].toLowerCase().includes(filter.value.toLowerCase())
            }
            columns={data.attributes.queueListViewColumnMap.map(h => ({
              accessor: camelCase(h.columnName),
              Header: h.displayHeader,
              show: !h.isHidden,
              Cell: d => <Cell data={d} header={h} />,
            }))}
            data={data.attributes.data}
            getTrProps={(state, rowInfo) => ({
              style: {
                cursor: 'pointer',
              },
              onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/patients/${rowInfo.original.patientUid}/face-sheet`, rowInfo.original)),
            })}
          />
        </>
      ) : (
        <PseudoStates isLoading={isLoading} error={error} />
      )}
    </PageLayout>
  );
};

export default QueuesIndex;
